import { z } from 'zod';

export const uuid = z.string().uuid();
export const optionalUuid = z.string().uuid().nullish();

/** Centavos: inteiro não negativo com teto razoável (R$ 10 milhões). */
export const cents = z.number().int().min(0).max(1_000_000_000);
export const optionalCents = cents.nullish();

export const quantity = z.number().positive().max(1_000_000);

export const trimmed = (max: number) => z.string().trim().max(max);
export const requiredText = (max: number, message = 'Campo obrigatório') => z.string().trim().min(1, message).max(max);
export const optionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .nullish()
    .transform((v) => (v ? v : null));

export const email = z.string().trim().toLowerCase().email('E-mail inválido').max(254);

export const password = z
  .string()
  .min(8, 'A senha precisa ter pelo menos 8 caracteres')
  .max(128, 'Senha muito longa');

export const paginationQuery = z.object({
  page: z.coerce.number().int().min(1).max(100000).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(30),
});

export const dateKey = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida (use AAAA-MM-DD)');

export const booleanish = z
  .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
  .transform((v) => v === true || v === 'true' || v === '1');

export const hexColor = z.string().regex(/^#[0-9A-Fa-f]{6}$/, 'Cor inválida');

export const idParam = z.object({ id: uuid });

export const periodQuery = z.object({
  period: z.enum(['today', 'yesterday', '7d', '30d', 'this_month', 'last_month', '90d', 'this_year', 'custom']).default('30d'),
  from: dateKey.optional(),
  to: dateKey.optional(),
});
export type PeriodQuery = z.infer<typeof periodQuery>;
